import type { CloudFile, CloudItem } from 'reactApp/modules/storage/storage.types';

export const isEBook = (item: CloudFile | CloudItem): boolean =>
    Boolean(item) && typeof item !== 'string' && 'subKind' in item && item?.subKind === 'ebook';
